/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DiscountTypeEnum } from './DiscountTypeEnum';
import {
    DiscountTypeEnumFromJSON,
    DiscountTypeEnumFromJSONTyped,
    DiscountTypeEnumToJSON,
    DiscountTypeEnumToJSONTyped,
} from './DiscountTypeEnum';
import type { Product } from './Product';
import {
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
    ProductToJSONTyped,
} from './Product';

/**
 * 
 * @export
 * @interface OfferProductApi
 */
export interface OfferProductApi {
    /**
     * 
     * @type {number}
     * @memberof OfferProductApi
     */
    productOfferId: number;
    /**
     * 
     * @type {Product}
     * @memberof OfferProductApi
     */
    product: Product;
    /**
     * 
     * @type {boolean}
     * @memberof OfferProductApi
     */
    isTransfer: boolean;
    /**
     * 
     * @type {number}
     * @memberof OfferProductApi
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof OfferProductApi
     */
    discount: number;
    /**
     * 
     * @type {DiscountTypeEnum}
     * @memberof OfferProductApi
     */
    discountType: DiscountTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof OfferProductApi
     */
    unitPrice: number;
    /**
     * 
     * @type {number}
     * @memberof OfferProductApi
     */
    total: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof OfferProductApi
     */
    timeDiscounts: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof OfferProductApi
     */
    firstPayment: number;
}



/**
 * Check if a given object implements the OfferProductApi interface.
 */
export function instanceOfOfferProductApi(value: object): value is OfferProductApi {
    if (!('productOfferId' in value) || value['productOfferId'] === undefined) return false;
    if (!('product' in value) || value['product'] === undefined) return false;
    if (!('isTransfer' in value) || value['isTransfer'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('discount' in value) || value['discount'] === undefined) return false;
    if (!('discountType' in value) || value['discountType'] === undefined) return false;
    if (!('unitPrice' in value) || value['unitPrice'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('timeDiscounts' in value) || value['timeDiscounts'] === undefined) return false;
    if (!('firstPayment' in value) || value['firstPayment'] === undefined) return false;
    return true;
}

export function OfferProductApiFromJSON(json: any): OfferProductApi {
    return OfferProductApiFromJSONTyped(json, false);
}

export function OfferProductApiFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferProductApi {
    if (json == null) {
        return json;
    }
    return {
        
        'productOfferId': json['productOfferId'],
        'product': ProductFromJSON(json['product']),
        'isTransfer': json['isTransfer'],
        'quantity': json['quantity'],
        'discount': json['discount'],
        'discountType': DiscountTypeEnumFromJSON(json['discountType']),
        'unitPrice': json['unitPrice'],
        'total': json['total'],
        'timeDiscounts': json['timeDiscounts'],
        'firstPayment': json['firstPayment'],
    };
}

export function OfferProductApiToJSON(json: any): OfferProductApi {
    return OfferProductApiToJSONTyped(json, false);
}

export function OfferProductApiToJSONTyped(value?: OfferProductApi | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productOfferId': value['productOfferId'],
        'product': ProductToJSON(value['product']),
        'isTransfer': value['isTransfer'],
        'quantity': value['quantity'],
        'discount': value['discount'],
        'discountType': DiscountTypeEnumToJSON(value['discountType']),
        'unitPrice': value['unitPrice'],
        'total': value['total'],
        'timeDiscounts': value['timeDiscounts'],
        'firstPayment': value['firstPayment'],
    };
}

